<template>
  <v-autocomplete
    class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.consultores"
    :items="consultoresAqui"
    label="Consultor/Gestor"
    item-text="nome"
    placeholder="Selecione.."
    multiple
    @change="$emit('onChange')"
    :clearable="true"
    :return-object="true"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon
          :color="filter.consultores.length > 0 ? 'indigo darken-4' : ''"
          >{{ icon }}</v-icon
        >
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{
          item.nome.length > 10 ? item.nome.substring(0, 10) + "..." : item.nome
        }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{
          filter.consultores.length - maxDisplay
        }}
        consultores/gestores)</span
      >
    </template>

    <template slot="no-data"> Nenhum Consultor/Gestor retornado </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "AppConsultoresCombobox",
  props: {
    filter: Object,
    consultores: Array,
  },
  computed: {
    likesAll() {
      return this.filter.consultores.length === this.consultoresAqui.length;
    },
    likesSome() {
      return this.filter.consultores.length > 0 && !this.consultoresAqui;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  data() {
    return {
      maxDisplay: 1,
      consultoresAqui: [],
    };
  },
  watch: {
    consultores(newValue, oldValue) {
      this.consultoresAqui = newValue;
    },
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.consultores = [];
          this.$emit("onChange", this.filter.consultores);
        } else {
          this.filter.consultores = this.consultoresAqui.slice();
          this.$emit("onChange", this.filter.consultores);
        }
      });
    },
  },
};
</script>
